module.exports = __webpack_public_path__ + "media/images/responsive/flow/waso_step02-c51fb304ba1bf8fbd1c0abf8cedd4e3f.jpg";